import { Button, FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { ActionHeader, FaqLink } from '..';
import en from '../../../../lang/en-us';
import { SubmitButton } from '../../../../lib/Button';
import { CustomRadio } from '../../../../lib/CustomRadio';
import { TableColumn, TableWithCollapse } from '../../../../lib/DataTable';
import { useTableWithCollapse } from '../../../../lib/DataTable/customHooks';
import { fetchInvestorDetails, sendPhoneOTP } from '../../../../redux-store/actions/nct';
import { RootStateType } from '../../../../redux-store/reducers';
import { BANK } from '../../../../redux-store/types/nct';
import { LIST_PROTFOLIO_PAYLOAD } from '../../../../redux-store/types/portfolio';
import {
    MULTIPLE_BANK_REGISTRATION,
    DEBT,
    EQUITY,
    LIQUID,
    OTHER,
    OTP_ACTIONS,
} from '../../../../utils/constants';
import { maskMobileNumber } from '../../../../utils/utilityFunctions';
import { PanSeedCheckNew } from '../../../common/PanSeedCheckNew';
import { NFT_TRXN_TYPE_MAP } from '../../commercial/utils';
import {
    getInvestorFunds,
    notLockedFolio,
    portfoliosByTransactionResource,
} from '../../portfolios/utils';
import { findDefaultBank, findDefaultBankIndex } from '../ChangeBank';
import { ConsolidateTableRowType } from '../ConsolidationFolios/types';
import NoFoliosFound from '../NoFoliosFound';
const { dashboard } = en;

export const ADD_BANK = 'addition';
export const DELETE_BANK = 'deletion';
export const CHANGE_DEFALUT = 'changeDefaultFlag';

const MenuList = [
    {
        label: dashboard.BankMandate.selectedFolios.radioOption1,
        value: ADD_BANK,
    },
    {
        label: dashboard.BankMandate.selectedFolios.radioOption2,
        value: DELETE_BANK,
    },
    {
        label: dashboard.BankMandate.selectedFolios.radioOption3,
        value: CHANGE_DEFALUT,
    },
];

export const Columns: TableColumn[] = [
    {
        field: 'id',
        headerName: 'FOLIO',
    },
    {
        field: 'amcName',
        headerName: 'Fund House',
        width: 250,
        filterBy: true,
        filterHeader: 'Fund House',
        filterKey: 'amcName',
    },
    {
        field: 'bank',
        headerName: 'DEFAULT BANK',
        valueGetter: ({ row }) => findDefaultBank(row)?.name || dashboard.notAvailable,
        width: 200,
    },
    {
        field: 'accountNo',
        headerName: 'ACCOUNT NUMBER',
        valueGetter: ({ row }) =>
            maskMobileNumber(findDefaultBank(row)?.accountNo) || dashboard.notAvailable,
        width: 200,
    },
    {
        field: 'investorName',
        headerName: 'PRIMARY HOLDER',
        valueGetter: ({ row }) => (row?.investorName || '').toUpperCase() || dashboard.notAvailable,
        width: 100,
    },
    {
        isFilter: true,
        field: 'assetType',
        headerName: 'Category',
        filterBy: true,
        renderStaticFilters: [EQUITY, LIQUID, DEBT, OTHER],
    },
];
function BankMandate(props: any) {
    const [rowData, setRowdata] = useState<ConsolidateTableRowType[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [actionType, setActionType] = useState<string | undefined>(ADD_BANK);
    const {
        selectedRows: targetFunds,
        setSelectedRows: setTargetFunds,
        resetTable,
        resetFilters,
        tableColumns,
        tableRows,
        ...filters
    } = useTableWithCollapse<ConsolidateTableRowType[]>({
        rows: rowData,
        columns: Columns,
        loading,
    });

    useEffect(() => {
        setLoading(true);
        async function callApi() {
            const payload: LIST_PROTFOLIO_PAYLOAD = {
                pan: props.pan,
                mobile: props.mobile,
                pekrn: props.pekrn,
                reqId: props.reqId,
            };
            try {
                const { body: investorDetails = {} } = await props.fetchInvestorDetails(payload);
                const { success: investorFundDetails = [] } = investorDetails;
                const bankFundRowData = getInvestorFunds(investorFundDetails, [
                    portfoliosByTransactionResource,
                    ({ bank = [] }: ConsolidateTableRowType): boolean =>
                        bank.findIndex(
                            (details: BANK) => details.default === 'Y' || details.default === '',
                        ) !== -1,
                    notLockedFolio,
                ]);
                setRowdata(bankFundRowData);
                setLoading(false);
            } catch (err: any) {
                alert(err.message);
            }
        }
        callApi();
        return () => {};
    }, []);

    useEffect(() => {
        resetFilters();
        setTargetFunds([]);
    }, [actionType]);

    const _isRowSeletable = ({ row }: { row: ConsolidateTableRowType }) => {
        const { bank = [] } = row;
        if (bank.length === 1 && actionType !== ADD_BANK) {
            return false;
        }
        if (actionType === ADD_BANK && targetFunds.length) {
            const [fund] = targetFunds;

            const rowDefaultBankIndex = findDefaultBankIndex(row);
            const fundDefaultBankIndex = findDefaultBankIndex(fund);

            const bankIfsc = fund.bank[fundDefaultBankIndex]?.ifsc.toUpperCase();
            const rowIfsc = row.bank[fundDefaultBankIndex]?.ifsc.toUpperCase();

            const accountNo = fund.bank[rowDefaultBankIndex]?.accountNo;
            const rowAccountNo = row.bank[rowDefaultBankIndex]?.accountNo;

            if (!(bankIfsc === rowIfsc && accountNo === rowAccountNo)) {
                return false;
            }
        }
        return true;
    };

    const _toolTipGetText = ({ row }: { row: ConsolidateTableRowType }) => {
        const { bank = [] } = row;
        if (bank.length === 1 && actionType !== ADD_BANK) {
            return dashboard.BankMandate.toolTipText;
        }
        if (actionType === ADD_BANK && targetFunds.length) {
            const [fund] = targetFunds;

            const rowDefaultBankIndex = findDefaultBankIndex(row);
            const fundDefaultBankIndex = findDefaultBankIndex(fund);

            const bankIfsc = fund.bank[fundDefaultBankIndex]?.ifsc.toUpperCase();
            const rowIfsc = row.bank[fundDefaultBankIndex]?.ifsc.toUpperCase();

            const accountNo = fund.bank[rowDefaultBankIndex]?.accountNo;
            const rowAccountNo = row.bank[rowDefaultBankIndex]?.accountNo;

            if (!(bankIfsc === rowIfsc && accountNo === rowAccountNo)) {
                return dashboard.ChangeBank.tooltip.info1;
            }
        }
        return '';
    };

    const handleSubmit = async () => {
        if (actionType === ADD_BANK) {
            props.history.push('bank-mandate-add-bank', {
                targetFunds,
                actionType,
                addBank: true,
            });
            return;
        }
        const { pan, pekrn, mobile } = props;
        try {
            let res = await props.sendPhoneOTP({
                mobile,
                pan,
                pekrn,
                action: OTP_ACTIONS.updateMultipleBanks,
            });
            props.history.push('bank-mandate-otp', {
                targetFunds,
                mobile,
                actionType,
                ...(res || {}).body,
                addBank: false,
            });
            setTargetFunds([]);
        } catch (err: any) {
            alert(err.message);
        }
    };

    const [callPanSeed, setCallPanSeed] = useState(false);

    const resetTrigger = () => {
        setCallPanSeed(false);
    };

    return (
        <div className="curved-bg">
            <PanSeedCheckNew
                callBackFn={handleSubmit}
                foliosArray={targetFunds}
                trxnType={NFT_TRXN_TYPE_MAP.multipleBankMandate}
                triggerCheck={callPanSeed}
                goBack={false}
                resetTrigger={resetTrigger}
            />
            <ActionHeader header={dashboard.BankMandate.BankMandateHeading} />
            <div className="curved-bg-content curved-bg-table-outer">
                <div className="curved-bg-content-table">
                    <CustomRadio
                        extraClass="custom-radio desktop_mode"
                        title={dashboard.BankMandate.selectOption}
                        name="select-dividend"
                        list={MenuList}
                        selectedValue={actionType}
                        handleRadioChange={(value: string) => setActionType(value)}
                    />
                    <FormControl variant="filled" className="mobile_mode">
                        <InputLabel id="change-bank-mandate-option-label">
                            {dashboard.BankMandate.selectOption}
                        </InputLabel>
                        <Select
                            labelId="change-bank-mandate-option-label"
                            id="change-bank-mandate-option"
                            value={actionType}
                            onChange={(e: any) => setActionType(e.target.value)}
                        >
                            {MenuList.map((item) => (
                                <MenuItem key={item.label} value={item.value}>
                                    {item.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <h5> {dashboard.BankMandate.BankMandateInfo}</h5>
                    <div className="curved-table-content">
                        {!loading && !tableRows.length ? (
                            <NoFoliosFound />
                        ) : (
                            <TableWithCollapse
                                rows={tableRows}
                                columns={tableColumns}
                                toolTipEnabled
                                checkBoxEnabled
                                disableAllSelection
                                isRowSelectable={_isRowSeletable}
                                toolTipTextGetter={_toolTipGetText}
                                selectedRows={targetFunds}
                                setSelectedRows={setTargetFunds}
                                resetFilters={resetFilters}
                                {...filters}
                            />
                        )}
                    </div>
                    <FaqLink section={MULTIPLE_BANK_REGISTRATION} history={props.history} />
                </div>
                <div className="curved-bg-content-inner-bottom">
                    {!!rowData.length && (
                        <div className="table-submit">
                            <SubmitButton
                                disabled={!targetFunds.length}
                                onClick={() => setCallPanSeed(true)}
                                // onClick={() => props.history.push('bank-mandate-selected', { targetFunds })}
                                label={dashboard.BankMandate.buttonText}
                                className="customBtn"
                            />
                        </div>
                    )}
                </div>
            </div>
            {/* <NoteModals
                showModal={show}
                heading={dashboard.BankMandate.noteModals.heading}
                info={dashboard.BankMandate.noteModals.info}
                proceedBtn={dashboard.BankMandate.noteModals.proceedText}
                cancelBtn={dashboard.BankMandate.noteModals.cancelText}
            /> */}
        </div>
    );
}
export default connect(({ authReducer }: RootStateType) => ({ ...authReducer }), {
    fetchInvestorDetails,
    sendPhoneOTP,
})(BankMandate);
